import { z } from 'zod';

import { InstanceIdType } from '#core/schema/defs.ts';
import { CogniteDescribableModel } from '#core/schema/model/cdm/CogniteDescribableModel.ts';
import { CogniteSourceableModel } from '#core/schema/model/cdm/CogniteSourceableModel.ts';
import { CogniteVisualizableModel } from '#core/schema/model/cdm/CogniteVisualizableModel.ts';

export const CogniteAssetBaseModel = z.object({
  ...CogniteVisualizableModel.shape,
  ...CogniteDescribableModel.shape,
  ...CogniteSourceableModel.shape,

  parent: InstanceIdType.optional(),
  root: InstanceIdType.optional(),
  path: InstanceIdType.array().optional(),
  pathLastUpdatedTime: z.coerce.date().optional(),
  assetClass: InstanceIdType.optional(),
  type: z.string().optional(),
  files: InstanceIdType.array().optional(),
  equipment: InstanceIdType.array().optional(),
  activities: InstanceIdType.array().optional(),
  timeSeries: InstanceIdType.array().optional(),
});

export const CogniteAssetModel = CogniteAssetBaseModel.extend({
  get parent() {
    return CogniteAssetModel.optional();
  },
  get root() {
    return CogniteAssetModel.optional();
  },
  get path() {
    return CogniteAssetModel.array().optional();
  },
  get children() {
    return CogniteAssetModel.array().optional();
  },
});

/** @public */
export type CogniteAssetModelInput = z.input<typeof CogniteAssetModel>;
/** @public */
export type CogniteAssetModelOutput = z.output<typeof CogniteAssetModel>;
